import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback, useEffect, useRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { bind } from 'bind-event-listener';
import { ReactRenderer } from '@atlaskit/renderer';
import { RendererActionsContext } from '@atlaskit/renderer/actions';
import { N800 } from '@atlaskit/theme/colors';
import { useAnalyticsFlow } from '../../../analytics/analytics-flow/analyticsFlowUtils';
import { isPartialCopy, isSelectionWithinElement } from '../../../experience-application/screens-with-logic/utils/copy-response';
export var PreviewRenderer = function PreviewRenderer(_ref) {
  var jsonDocument = _ref.jsonDocument,
    showTelepointer = _ref.showTelepointer,
    providerFactory = _ref.providerFactory;
  var analyticsFlow = useAnalyticsFlow();
  var previewRendererRef = useRef(null);
  var copiedOnceRef = useRef(false);
  var onCopyHandler = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var previewRendererElement;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          previewRendererElement = previewRendererRef.current;
          if (!(!analyticsFlow || !previewRendererElement)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          if (isSelectionWithinElement(previewRendererElement)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          if (isPartialCopy(previewRendererRef.current)) {
            analyticsFlow.addAttributes({
              contentCopiedPartially: true
            });
          }

          // exit if copied already for this preview
          if (!copiedOnceRef.current) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          analyticsFlow.addAttributes({
            contentCopied: true
          });
          copiedOnceRef.current = true;
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [analyticsFlow]);
  useEffect(function () {
    var unbind = bind(document, {
      type: 'copy',
      listener: onCopyHandler
    });
    return unbind;
  }, [onCopyHandler, analyticsFlow]);

  // override renderer's syntax highlighting styles so it appears consistent with the editor
  var styles = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code-block .token.token': {
      fontStyle: 'normal',
      fontWeight: 'normal',
      color: "var(--ds-text, ".concat(N800, ")")
    }
  });
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", {
      "data-testid": "preview-renderer",
      css: styles,
      ref: previewRendererRef
    }, jsx(RendererActionsContext, null, jsx(ReactRenderer, {
      document: jsonDocument,
      media: {
        // We don't currently support images with captions
        allowLinking: false
      }
      // By default -- the renderer uses a "default schema" which supports all
      // the nodes and marks the markdown transformer can create.
      // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
      ,
      useSpecBasedValidator: true,
      addTelepointer: showTelepointer,
      dataProviders: providerFactory,
      allowPlaceholderText: true
    })))
  );
};